// extracted by mini-css-extract-plugin
export var emailBlockLink = "_lh-0";